import React from "react";
import Utils from "./utils";
import { Typography } from "antd";

const { Text } = Typography;
const { AccessTypeBox, LabelRow } = Utils;

const getLabel = (p) => {
	const slugs = p?.subPermission?.values;
	if (slugs && slugs.length) {
		const map = p?.subPermission?.defaults || {};
		const subPermissionsStr = slugs.map((slug) => map[slug]).join(", ");
		return `${p.label} (${subPermissionsStr})`;
	}
	return p.label;
};

const AccessBox = ({ isAdmin, permissionsData }) => {
	return (
		<div style={{ display: "flex", flexDirection: "row" }}>
			<AccessTypeBox
				isAdmin={isAdmin}
				styles={{ width: "40px", height: "40px" }}
				iconSize="1.5rem"
			/>
			<div
				style={{
					marginLeft: "1rem",
					justifyContent: "space-between",
					display: "flex",
					flexDirection: "column",
					flexGrow: 1,
				}}
			>
				<div
					style={{
						flexDirection: "column",
						display: "flex",
					}}
				>
					<Text style={{ fontSize: "14px", color: "#1D2624" }} strong>{`${
						isAdmin ? "Admin" : "Employee"
					} access`}</Text>
					<Text
						style={{
							marginBottom: isAdmin ? "1rem" : 0,
							color: "#828786",
							fontSize: "14px",
						}}
					>
						You can edit or update the permission for this profile
					</Text>
					{!isAdmin &&
						permissionsData.map((p) => {
							return <PermissionsBox data={p} key={`${p.type}_outer_box`} />;
						})}
				</div>

				{isAdmin && (
					<div
						style={{
							flexDirection: "column",
							display: "flex",
						}}
					>
						<Text style={{ fontSize: "14px", color: "#363E3D" }} strong>
							Full Control
						</Text>
						<Text style={{ color: "#686E6D", fontSize: "14px" }}>
							User has control on all modules of the platform
						</Text>
					</div>
				)}
			</div>
		</div>
	);
};

const PermissionsBox = ({ data }) => {
	const isModuleOff =
		data?.permissions.filter((p) => p.toggleValue)?.length === 0;
	return (
		<div
			style={{
				marginTop: "1.5rem",
				display: "flex",
				flexDirection: "column",
			}}
		>
			<Text
				style={{ marginBottom: "0.3rem", color: "#363E3D", fontSize: "14px" }}
			>
				{data.type}
			</Text>
			{isModuleOff && (
				<LabelRow label="No access to this module" isModuleOff={isModuleOff} />
			)}
			{!isModuleOff &&
				data?.permissions
					?.sort((a, b) => a.order - b.order)
					.map((p, index) => {
						const label = getLabel(p);
						if (p.slug.includes("grantAll_")) return null;
						return (
							<LabelRow
								key={`${data.type}_${index}`}
								label={label}
								toggleValue={p.toggleValue}
							/>
						);
					})}
		</div>
	);
};

const UserMemberCard = ({ user, handleEditUser, handleRemoveUser }) => {
	const permissionsData = Utils.tranformPermissions(user.permissions);
	const myself = user.userId === JSON.parse(localStorage.getItem("userId"));
	const customName = myself
		? `${user.first_name} ${user.last_name} (You)`
		: `${user?.first_name ? user?.first_name :user?.email} ${user?.last_name}`;
	return (
		<div>
			<div
				style={{
					display: "flex",
					flexDirection: "column",
					marginBottom: "1rem",
				}}
			>
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						justifyContent: "space-between",
					}}
				>
					<Text strong style={{ fontSize: "16px", color: "#1D2624" }}>
						{customName}
					</Text>
					<div>
						{/*	<Text
							onClick={handleRemoveUser}
							style={{
								cursor: "pointer",
								fontSize: "16px",
								color: "#0B7764",
								marginRight: "1rem",
							}}
						>
							Remove user
						</Text>*/}

						{!myself && (
							<Text
								onClick={() => handleEditUser(user)}
								style={{
									cursor: "pointer",
									fontSize: "16px",
									color: "#0B7764",
								}}
							>
								Edit Profile
							</Text>
						)}
					</div>
				</div>

				<Text style={{ color: "#828786" }}>{`Email : ${user.email}`}</Text>
				{/*	<Text
					style={{ color: "#828786" }}
				>{`IP address : ${user.allowedIpAddress}`}</Text>*/}
			</div>
			<AccessBox isAdmin={user.isAdmin} permissionsData={permissionsData} />
		</div>
	);
};

export default UserMemberCard;
